import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = { id: "content" }
const _hoisted_3 = { id: "content-center" }
const _hoisted_4 = { id: "content-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapView = _resolveComponent("MapView")!
  const _component_selector = _resolveComponent("selector")!
  const _component_Stats = _resolveComponent("Stats")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MapView),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_selector)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Stats)
      ])
    ])
  ]))
}